import {Component, ElementRef, Inject, OnInit, Renderer2} from '@angular/core';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConteudoColunaRim} from "../../../../core/conteudo-coluna-rim";
import {ConteudoRim} from "../../../../core/conteudo-rim";
import {ToastService} from "../../../../services/toast/toast.service";

@Component({
    selector: 'largura-tabel-dialog',
    templateUrl: './largura-coluna-tabela-dialog.component.html',
    styleUrls: ['./largura-coluna-tabela-dialog.component.css']
})
export class LarguraColunaTabelaDialogComponent implements OnInit {

    private startMouseX!: number;
    private startWidth!: number;

    pinRandom = Math.random();

    conteudo: ConteudoRim;
    larguraTotal: number = 565;
    larguraTotalFixa: boolean = false;

    constructor(private dialogRef: MatDialogRef<LarguraColunaTabelaDialogComponent>,
                private el: ElementRef,
                private renderer: Renderer2,
                @Inject(MAT_DIALOG_DATA) data: any,
                private toastService: ToastService) {
        if (data) {
            this.larguraTotal = data.larguraTotal;
            this.conteudo = data.conteudo;

            dialogRef.disableClose = data.disableClose;
        }

    }

    ngOnInit() {
    }

    voltar() {
        this.dialogRef.close();
    }

    onChageLarguraColuna() {
        if (this.larguraTotal > 565) {
            this.toastService.showAlerta("A largura total das colunas não pode ser maior que 565.");
            this.larguraTotal = 565;
            this.atualizarLarguraTotal();
        }
    }

    onMouseDownResizer(event: MouseEvent) {
        event.preventDefault();
        const parent = this.el.nativeElement.parentElement;
        const htmlColumn = parent.getElementsByClassName("th_" + event.target["id"])[0];

        if (!htmlColumn) return;

        this.startMouseX = event.pageX;
        this.startWidth = htmlColumn.offsetWidth;

        const columnPosition = parseInt(event.target["id"].split("_")[2]);
        const currentColumn = this.conteudo.colunas.find(item => item.posicao === columnPosition);

        const mouseMoveListener = this.renderer.listen('document', 'mousemove', (e: MouseEvent) =>
            this.onMouseMove(e, currentColumn)
        );

        const mouseUpListener = this.renderer.listen('document', 'mouseup', () => {
            mouseMoveListener();
            mouseUpListener();

            const widthColunaHtml = htmlColumn.offsetWidth;
            if (widthColunaHtml !== currentColumn.largura)
                currentColumn.largura = widthColunaHtml;

            if (this.larguraTotalFixa)
                this.validarLarguraColunas();
        });
    }

    validarLarguraColunas() {
        const parent = this.el.nativeElement.parentElement;

        this.conteudo.colunas.forEach(coluna => {
            const idHtml = "th_coluna_" + this.pinRandom + "_" + coluna.posicao;
            const htmlColumn = parent.getElementsByClassName(idHtml)[0];

            const widthColunaHtml = htmlColumn.offsetWidth;
            if (widthColunaHtml !== coluna.largura) {
                coluna.largura = widthColunaHtml;
            }
        });
        this.atualizarLarguraTotal();
    }

    private onMouseMove(event: MouseEvent, currentColumn: ConteudoColunaRim) {
        if (!currentColumn) return;

        const newWidthForColumn = this.startWidth + (event.pageX - this.startMouseX);
        const widthChange = newWidthForColumn - currentColumn.largura;

        if (newWidthForColumn < 10) return;

        currentColumn.largura = Math.round(newWidthForColumn);

        if (this.larguraTotalFixa) {
            this.atualizarOutrasColunas(currentColumn, widthChange);
        } else {
            this.atualizarLarguraTotal();
            if (this.larguraTotal > 565) {
                currentColumn.largura = 565 - (this.larguraTotal - currentColumn.largura);
                this.atualizarLarguraTotal();
            }
        }

    }

    private atualizarOutrasColunas(currentColumn: ConteudoColunaRim, widthChange: number) {
        const outrasColunas = this.conteudo.colunas.filter(item => item.posicao !== currentColumn.posicao);
        const totalLarguraColunas = outrasColunas.reduce((sum, col) => sum + col.largura, 0);

        outrasColunas.forEach(col => {
            const proporcaoLargura = widthChange * (col.largura / totalLarguraColunas);
            col.largura = Math.max(10, Math.round(col.largura - proporcaoLargura));
        });
    }

    private atualizarLarguraTotal() {
        this.larguraTotal = this.conteudo.colunas.reduce((acc, item) => acc + item.largura, 0);
    }

}